/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MstCalendar
 */
export interface MstCalendar {
    /**
     * 
     * @type {number}
     * @memberof MstCalendar
     */
    companyId: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstCalendar
     */
    orgCenterId: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCalendar
     */
    calendarDate: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCalendar
     */
    enableShip: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCalendar
     */
    enableArrival: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCalendar
     */
    enableOrder: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof MstCalendar
     */
    arrivalRatio: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstCalendar
     */
    remarks: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCalendar
     */
    deleteFlg: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCalendar
     */
    insertDatetime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCalendar
     */
    insertUser: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCalendar
     */
    updateDatetime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCalendar
     */
    updateUser: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCalendar
     */
    deleteDatetime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCalendar
     */
    deleteUser: string | null;
}

/**
 * Check if a given object implements the MstCalendar interface.
 */
export function instanceOfMstCalendar(value: object): value is MstCalendar {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('orgCenterId' in value) || value['orgCenterId'] === undefined) return false;
    if (!('calendarDate' in value) || value['calendarDate'] === undefined) return false;
    if (!('enableShip' in value) || value['enableShip'] === undefined) return false;
    if (!('enableArrival' in value) || value['enableArrival'] === undefined) return false;
    if (!('enableOrder' in value) || value['enableOrder'] === undefined) return false;
    if (!('arrivalRatio' in value) || value['arrivalRatio'] === undefined) return false;
    if (!('remarks' in value) || value['remarks'] === undefined) return false;
    if (!('deleteFlg' in value) || value['deleteFlg'] === undefined) return false;
    if (!('insertDatetime' in value) || value['insertDatetime'] === undefined) return false;
    if (!('insertUser' in value) || value['insertUser'] === undefined) return false;
    if (!('updateDatetime' in value) || value['updateDatetime'] === undefined) return false;
    if (!('updateUser' in value) || value['updateUser'] === undefined) return false;
    if (!('deleteDatetime' in value) || value['deleteDatetime'] === undefined) return false;
    if (!('deleteUser' in value) || value['deleteUser'] === undefined) return false;
    return true;
}

export function MstCalendarFromJSON(json: any): MstCalendar {
    return MstCalendarFromJSONTyped(json, false);
}

export function MstCalendarFromJSONTyped(json: any, ignoreDiscriminator: boolean): MstCalendar {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['company_id'],
        'orgCenterId': json['org_center_id'],
        'calendarDate': (json['calendar_date'] == null ? null : new Date(json['calendar_date'])),
        'enableShip': json['enable_ship'],
        'enableArrival': json['enable_arrival'],
        'enableOrder': json['enable_order'],
        'arrivalRatio': json['arrival_ratio'],
        'remarks': json['remarks'],
        'deleteFlg': json['delete_flg'],
        'insertDatetime': (json['insert_datetime'] == null ? null : new Date(json['insert_datetime'])),
        'insertUser': json['insert_user'],
        'updateDatetime': (json['update_datetime'] == null ? null : new Date(json['update_datetime'])),
        'updateUser': json['update_user'],
        'deleteDatetime': (json['delete_datetime'] == null ? null : new Date(json['delete_datetime'])),
        'deleteUser': json['delete_user'],
    };
}

export function MstCalendarToJSON(json: any): MstCalendar {
    return MstCalendarToJSONTyped(json, false);
}

export function MstCalendarToJSONTyped(value?: MstCalendar | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company_id': value['companyId'],
        'org_center_id': value['orgCenterId'],
        'calendar_date': value['calendarDate'] == null ? value['calendarDate'] : value['calendarDate'].toISOString().substring(0,10),
        'enable_ship': value['enableShip'],
        'enable_arrival': value['enableArrival'],
        'enable_order': value['enableOrder'],
        'arrival_ratio': value['arrivalRatio'],
        'remarks': value['remarks'],
        'delete_flg': value['deleteFlg'],
        'insert_datetime': value['insertDatetime'] == null ? value['insertDatetime'] : value['insertDatetime'].toISOString(),
        'insert_user': value['insertUser'],
        'update_datetime': value['updateDatetime'] == null ? value['updateDatetime'] : value['updateDatetime'].toISOString(),
        'update_user': value['updateUser'],
        'delete_datetime': value['deleteDatetime'] == null ? value['deleteDatetime'] : value['deleteDatetime'].toISOString(),
        'delete_user': value['deleteUser'],
    };
}

